import { gql } from "@apollo/client";

export default gql`
  mutation updateChangelogSettings($input: UpdateChangelogSettingsInput!){
    updateChangelogSettings(input: $input){
        success
        data{
            _id
            defaultLanguage
            supportedLanguages
            defaultTimezone
            dateFormat
            senderEmail
            senderWhatsapp
            senderCustomerId
            recipientAudience
            includeInactiveCustomers
            includeArchivedPersons
            updatedAt
        }
        error
        message
    }
}
`
